export default {"kitTag":"FHB-f","text":"RZvux"};